<template>
  <div class="personnel-portrait-content">
    <div class="content-header">
      <e-form
        :field-list="formInfo.fieldList"
        :data="formInfo.data"
        :list-type-info="formInfo.listTypeInfo"
        ref="formRef"
        @handleEvent="formChange('formInfo',$event)"
      >
        <template v-slot:form-submit>
          <el-button type="primary" @click="queryInfo">查询</el-button>
          <el-button type="primary" @click="resetForm">重置</el-button>
        </template>
      </e-form>
    </div>
    <div class="content">
      <div class="content-row">
        <div class="content-column">
          <chart
            :chartConfig="[
                {
                  name:'lineChart',
                  option: outConfig.option,
                  load: outConfig.load,
                  clear: outConfig.clear,
                }
              ]"
          />
        </div>
      </div>
      <div class="content-row">
        <div class="content-column">
          <chart
            :chartConfig="[
                {
                  name:'lineChart',
                  option: proLineConfig.option,
                  load: proLineConfig.load,
                  clear: proLineConfig.clear,
                }
              ]"
          />
        </div>
      </div>
      <div class="content-row">
        <div class="content-column">
          <div class="table-title-style">整体达标率详细信息</div>
          <div class="export-btn-style" @click="exportInfo">导出</div>
          <lb-table
            :column="table.tableColumn"
            :data="table.data"
            :pagination="true"
            :page-size="table.pageSize"
            :total="table.totalCount"
            :current-page="table.pageNo"
            @current-change="onPageNoChange"
            border
          >
          </lb-table>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import EForm from '@/components/EForm/index'
import LbTable from '@/components/lb-table/lb-table'
import chart from '@/components/chart/index'
import {
  formInfo,
  outConfig,
  proLineConfig,
  table
}
  from './config'
import { common } from '../mixFun'
import { getOutAndProLineRate, getPassRateDetail, passRateDetaiExport } from '@/api/personnelWorkHour'
import { downloadBlobFile } from '@/utils/download'
export default {
  name: 'OverallcomplianceDetail',
  mixins: [common],
  components: {
    EForm,
    chart,
    LbTable
  },
  data () {
    return {
      formInfo,
      outConfig,
      proLineConfig,
      table,
      formData: formInfo.data
    }
  },
  mounted () {
    this.init()
  },
  methods: {
    queryInfo () {
      this.formData = {
        ...this.formData,
        ...this.$refs.formRef.data
      }
      this.outConfig.clear = true
      this.proLineConfig.clear = true
      this.drawChart()
    },
    resetForm () {
      this.$refs.formRef.resetFields()
    },
    init () {
      this.drawChart()
    },
    drawChart () {
      this.getOutData()
      this.getProLIneData()
      this.getTableInfo()
    },
    onPageNoChange (current) {
      this.getTableInfo({ pageNo: current, pageSize: 10 })
    },
    // 获取各供应商整体达标率
    async getOutData () {
      this.outConfig.load = true
      const res = await getOutAndProLineRate({ ...this.formData, dimension: 'outsourcer' })
      this.outConfig.option = {
        title: {
          text: '各供应商整体达标率'
        },
        legend: {
          show: true,
          top: 27
        },
        xAxis: {
          type: 'category',
          data: res.rows
        },
        yAxis: {
          type: 'value',
          splitLine: {
            show: true
          },
          axisLine: {
            show: false
          },
          axisLabel: {
            show: true,
            formatter (params) {
              return `${params * 100}%`
            }
          }
        },
        series: res.column.type.map(item => ({
          type: 'line',
          name: item,
          label: {
            show: true,
            formatter (params) {
              return `${(Number(params.value) * 100).toFixed(2)}%`
            }
          },
          markLine: {
            lineStyle: {
              color: 'red'
            },
            data: [
              {
                name: '目标',
                yAxis: res.standard
              }
            ],
            label: {
              formatter (params) {
                return `${params.value * 100}%`
              }
            }
          },
          data: res.column.data[item]
        }))
      }
      this.outConfig.load = false
      this.outConfig.clear = false
    },
    async getProLIneData () {
      this.proLineConfig.load = true
      const res = await getOutAndProLineRate({ ...this.formData, dimension: 'production_line' })
      this.proLineConfig.option = {
        title: {
          text: '各产线整体达标率'
        },
        legend: {
          show: true,
          top: 27
        },
        xAxis: {
          type: 'category',
          data: res.rows
        },
        yAxis: {
          type: 'value',
          splitLine: {
            show: true
          },
          axisLine: {
            show: false
          },
          axisLabel: {
            show: true,
            formatter (params) {
              return `${params * 100}%`
            }
          }
        },
        series: res.column.type.map(item => ({
          type: 'line',
          name: item,
          label: {
            show: true,
            formatter (params) {
              return `${(Number(params.value) * 100).toFixed(2)}%`
            }
          },
          markLine: {
            lineStyle: {
              color: 'red'
            },
            data: [
              {
                name: '目标',
                yAxis: res.standard
              }
            ],
            label: {
              formatter (params) {
                return `${params.value * 100}%`
              }
            }
          },
          data: res.column.data[item]
        }))
      }
      this.proLineConfig.load = false
      this.proLineConfig.clear = false
    },
    async exportInfo () {
      const res = await passRateDetaiExport(this.formData)
      downloadBlobFile(res)
    },
    // 获取表格信息
    async getTableInfo (params = { pageNo: 1, pageSize: 10 }) {
      const res = await getPassRateDetail({ ...this.formData, ...params })
      this.table.data = res.data
      this.table.pageNo = res.pageNo
      this.table.totalCount = res.totalCount
      this.table.pageSize = res.pageSize
    }
  }
}
</script>

<style scoped lang="less">
@import "../../../utils/utils.less";

.table-title-style {
  font-size: 14px;
  text-align: center;
  margin-bottom: 20px;
  margin-top: 10px;
}

.export-btn-style {
  cursor: pointer;
  color: #5ABFE8;
  font-size: 14px;
  text-align: right;
}
</style>
